import { AdvancedEditorContext, AdvancedEditorContextType } from '@/pages/AdvancedEditor/context/AdvancedEditorContext';
import { useContext } from 'react';

export const useAdvancedEditorContext = (): AdvancedEditorContextType => {
    const context = useContext(AdvancedEditorContext);

    if (!context) {
        throw Error('You are outside of AdvancedEditorContextProvider');
    }

    return context;
};
